module.exports = __webpack_public_path__ + "img/ic-white-pontos-interesse.ffcbe443.svg";